module.exports = __webpack_public_path__ + "stylesheets/section-text-aside_e13044f9f9b71ad1dc331941fe80b9b2.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-text-aside.less
// module id = OmPd
// module chunks = 118